export default __webpack_public_path__ + "static/O0199-7867aa4ceff40537cbc707cbd9956d48.png";